import { programs } from "@/mocks/festival";

export default function Programs() {
  return (
    <section id="programs" className="w-full bg-primary-900 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="reveal mb-10 md:mb-14">
          <span className="text-xs tracking-[0.24em] text-accent-300">PROGRAM</span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-white">
            한눈에 보는 대표 프로그램
          </h2>
          <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-background-200">
            품평회와 시식회, 수확체험, 가요제와 농특산물 장터까지.
            입장거봉포도축제에서 만날 수 있는 다채로운 프로그램을 소개합니다.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {["관람 무료", "주차 가능", "온 가족 프로그램", "산지 직거래"].map((badge) => (
              <span
                key={badge}
                className="rounded-full border border-white/20 bg-white/10 px-3.5 py-1.5 text-xs text-white"
              >
                {badge}
              </span>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {programs.map((program, i) => (
            <article
              key={program.name}
              className={`reveal reveal-delay-${(i % 3) + 1} group overflow-hidden rounded-lg border border-white/10 bg-white/5`}
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={program.src}
                  alt={program.alt}
                  width={1100}
                  height={780}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500/90 px-3 py-1 text-[11px] font-medium text-white backdrop-blur-sm">
                  {program.tag}
                </span>
              </div>
              <div className="px-5 py-5 md:px-6 md:py-6">
                <h3 className="font-heading text-lg text-white">{program.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-200">{program.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}